import TileType from '~/constants/TileType';
import type { ConditionalTile } from '~/contracts';

export type ExternalProps = {
  hasActiveTrade: boolean;
  pageNumber: number;
};

type InternalProps = {
  isShowingSaveSearch: boolean;
};

type OwnProps = ExternalProps & InternalProps;

export default function getTradeInTile({
  hasActiveTrade,
  isShowingSaveSearch,
  pageNumber
}: OwnProps): ConditionalTile {
  const active = !hasActiveTrade;

  const initialIndex = isShowingSaveSearch ? 18 : 17;
  const index = pageNumber > 1 ? 14 : initialIndex;

  return { active, index, tileType: TileType.TradeIn };
}
